import React from "react";
import { Button } from "@progress/kendo-react-buttons";
import { chartLineIcon } from "@progress/kendo-svg-icons";

const ShowLogsButton = (properties: React.ComponentProps<typeof Button>) => (
  <Button themeColor="secondary" fillMode="link" style={{ padding: 0 }} svgIcon={chartLineIcon} {...properties}>
    Show Logs
  </Button>
);

export default ShowLogsButton;
